// require('../../../node_modules/jquery/dist/jquery.min');

window.$ = window.jQuery = require('jquery');
import 'jquery-ui/ui/widgets/autocomplete.js';

var _ = require('lodash');
require('./libs/floatingAlert');
require('./libs/slider');
require('./libs/quotation');
require('./libs/autocompletePostcode');

$(document).ready(function () {
  $('.js-language-trigger').click(function () {
    $('.js-language-options').toggleClass('active');
  });

  $('.faq-item .btn').click(function () {
    if ($(this).parent().next('.faq__answer').is(':visible')) {
      $(this).parent().next('.faq__answer').slideUp('slow');
    } else {
      $('.faq__answer').slideUp('slow');
      $(this).parent().next('.faq__answer').slideDown('fast');
    }
  });

  $('.main-menu-trigger').click(function () {
    $('.main-menu-trigger').toggleClass('active');
    $('.main-menu-wrap').toggleClass('active');
  });

  $('.js-toggle-regional').click(function () {
    $('.regional-offices-container').slideToggle();
    $('html,body').animate(
      { scrollTop: $('.regional-offices-container').offset().top },
      'slow'
    );
  });

  $('.js-login-trigger').click(function () {
    $('.js-login-dropdown').fadeToggle();
  });

  $('.js-logout-trigger').click(function (e) {
    e.preventDefault();
    document.getElementById('logout-form').submit();
  });

  $('.login-dropdown__close').click(function () {
    $('.js-login-dropdown').fadeOut();
  });

  $('.notification-banner-close').click(function () {
    $('.notification-banner').fadeOut();
    localStorage.setItem('closed-notification-banner', true);
  });

  $('.notification-banner-cta').click(function () {
    localStorage.setItem('closed-notification-banner', true);
  });

  $('.accordion .trigger').click(function () {
    $(this).closest('.accordion').toggleClass('active');
  });

  if (localStorage.getItem('closed-notification-banner') == null) {
    $('.notification-banner').fadeIn();
  }

  /* ===== Logic for creating fake Select Boxes ===== */
  $('.custom-select').each(function () {
    $(this).children('select').css('display', 'none');

    let $current = $(this);

    $(this)
      .find('option')
      .each(function (i) {
        if (i === 0) {
          $current.prepend(
            $('<div/>', {
              class: $current
                .attr('class')
                .replace(/custom-select/g, 'custom-select__box'),
            })
          );

          let placeholder = $(this).text();
          $current.prepend(
            $('<span/>', {
              class: $current
                .attr('class')
                .replace(/custom-select/g, 'custom-select__placeholder'),
              text: placeholder,
              'data-placeholder': placeholder,
            })
          );

          return;
        }

        $current.children('div').append(
          $('<span/>', {
            class: $current
              .attr('class')
              .replace(/custom-select/g, 'custom-select__box-options'),
            text: $(this).text(),
          })
        );
      });
  });

  // Toggling the `.active` state on the `.sel`.
  $('.custom-select').click(function () {
    $(this).toggleClass('active');
  });

  // Toggling the `.selected` state on the options.
  $('.custom-select__box-options').click(function () {
    let txt = $(this).text();
    let index = $(this).index();

    $(this).siblings('.custom-select__box-options').removeClass('selected');
    $(this).addClass('selected');

    let $currentSel = $(this).closest('.custom-select');
    $currentSel.children('.custom-select__placeholder').text(txt);
    $currentSel.children('select').prop('selectedIndex', index + 1);
  });

  // Scroll to flash message
  if ($('#js-flash').length) {
    $('html,body').animate({
      scrollTop: $('#js-flash').offset().top - 250,
    });
  }

  // login / forgot password
  $('.js-login-submit').on('click', function (e) {
    e.preventDefault();

    var username = $("input[name='user']").val();
    var password = $("input[name='passwd']").val();
    var fID;
    var _token = $('input[name="_token"]').val();

    if ($('#js-loginFranchise').length) {
      fID = $("select[name='fID']").val();
    } else {
      fID = $("input[name='fID']").val();
    }

    var userErr = $('.js-username-error');
    var pswErr = $('.js-password-error');
    var fIDErr = $('.js-fID-error');
    var loginErr = $('.js-login-error');
    var forgotPswOk = $('.js-reset-password');

    $.ajax({
      url: '/login',
      type: 'POST',
      dataType: 'json',
      data: {
        _token: _token,
        username: username,
        password: password,
        fID: fID,
      },
      success: function (response) {
        if ($.isEmptyObject(response.error)) {
          window.location.href = response.success;
        } else {
          if (response.error.login != null) {
            loginErr.css('display', 'block');
            loginErr.html(response.error.login);
          }
        }
      },
      error: function (jqXhr) {
        //userErr.addClass('d-none');
        userErr.css('display', 'none');
        pswErr.css('display', 'none');
        fIDErr.css('display', 'none');
        forgotPswOk.css('display', 'none');

        var errors = jqXhr.responseJSON;
        $.each(errors, function (index, error) {
          if (error.username) {
            userErr.css('display', 'block');
            userErr.html(error.username);
          }
          if (error.password) {
            pswErr.css('display', 'block');
            pswErr.html(error.password);
          }
          if (error.fID) {
            fIDErr.css('display', 'block');
            fIDErr.html(error.fID);
          }
        });
      },
    });
  });

  // forgot password
  $('.js-forgot-password-submit').on('click', function (e) {
    e.preventDefault();

    var username = $("input[name='forgot_user']").val();
    var fID;

    if ($('#js-fg-loginFranchise').length) {
      fID = $("select[name='forgot_fID']").val();
    } else {
      fID = $("input[name='forgot_fID']").val();
    }

    var userErr = $('.js-fg-username-error');
    var fIDErr = $('.js-fg-fID-error');
    var loginErr = $('.js-forgot-error');
    var successForgot = $('.js-reset-password');
    alert('a');
    $.ajax({
      url: '/forgot.html',
      type: 'POST',
      dataType: 'json',
      data: {
        username: username,
        fID: fID,
      },
      success: function (response) {
        alert('b');
        console.log(response);
        userErr.css('display', 'none');
        fIDErr.css('display', 'none');

        if ($.isEmptyObject(response.error)) {
          if (response.success == true) {
            // show login form
            $('.js-forgot-password-form').hide();
            $('.js-login-form').show();
            successForgot.text('Check your Email');
            successForgot.show();
          }
        } else {
          alert('C');
          console.log(response);
          if (response.error.username != null) {
            userErr.css('display', 'block');
            userErr.html(response.error.username);
          }
          if (response.error.fID != null) {
            fIDErr.css('display', 'block');
            fIDErr.html(response.error.fID);
          }
          if (response.error.login != null) {
            loginErr.css('display', 'block');
            loginErr.html(response.error.login);
          }
        }
      },
      error: function (xhr) {
        console.log(xhr);
      },
    });
  });

  $('.js-forgot-password').on('click', function (e) {
    e.preventDefault();
    $('.js-login-form').hide();
    $('.js-forgot-password-form').show();
  });

  $('.js-show-login').on('click', function (e) {
    e.preventDefault();

    $('.js-forgot-password-form').hide();
    $('.js-login-form').show();
  });
});
